"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQRCodeHTML = void 0;
const interfaces_1 = require("./interfaces");
const generateQRCodeHTML = (qrCode) => {
    return `
    <!DOCTYPE html>
    <html>
    <style>
    .${interfaces_1.PREFIX}qrcode-image {
        max-width: 201px;
        max-height: 201px;
      }
    </style>
    <body>
        <img src="data:image/webp;base64,${qrCode}" alt="QRCode" class="${interfaces_1.PREFIX}qrcode-image" />
    </body>
    </html>
    `;
};
exports.generateQRCodeHTML = generateQRCodeHTML;
